import axios from 'axios';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import API from 'api';

// Add video
export const addVideo = createAsyncThunk(
  'video/addVideo',
  async (videodata, { rejectWithValue }) => {
    try {
      const response = await API.post('/videos/createVideo', videodata);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to add video');
    }
  }
);

// Fetch data
export const fetchVideo = createAsyncThunk(
  'video/fetchVideo',
  async (_, { rejectWithValue }) => {
    try {
      const response = await API.get('/videos/getVideo');
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch video data');
    }
  }
);


// delete video
export const deleteVideo = createAsyncThunk(
  'video/deleteVideo',
  async (id, { rejectWithValue }) => {
    try {
      const response = await API.delete(`/videos/deleteVideo/${id}`);
      return id;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "failed to delete video")
    }
  }
)

// Update Video
export const updateVideo = createAsyncThunk(
  "video/updateVideo",
  async (updateVideo, { rejectWithValue }) => {
    try {
      const response = await API.put(`/videos/updateVideo/${updateVideo._id}`, updateVideo);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Failed to update video")
    }
  }
)


const videoSlice = createSlice({
  name: 'video',
  initialState: {
    videos: [],
    status: 'idle',
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Add Video
      .addCase(addVideo.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(addVideo.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.successMessage = action.payload.message;
        state.videos.push(action.payload.video);
      })
      .addCase(addVideo.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      })

      // Fetch All Videos
      .addCase(fetchVideo.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchVideo.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.videos = action.payload;
      })
      .addCase(fetchVideo.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      })

      // delete video
      .addCase(deleteVideo.pending, (state) => {
        state.status = "loading";
        state.error = null
      })
      .addCase(deleteVideo.fulfilled, (state, action) => {
        state.status = "succeded";
        state.videos = state.videos.filter((video) => video._id !== action.payload);
      })
      .addCase(deleteVideo.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload
      })

      // update video
      .addCase(updateVideo.fulfilled, (state, action) => {
        const updatedVideo = action.payload;
        const index = state.videos.findIndex((video) => video._id === updatedVideo._id);
        if (index !== -1) {
            state.videos[index] = updatedVideo;
        }
    });
  },
});

export default videoSlice.reducer;
